import React from "react";
import { Button as EDSButton } from "@chanzuckerberg/eds";
import { ActionType } from "utils/analytics/analyticsConstants";
import { useAnalytics } from "utils/analytics/AnalyticsContext";
import { AnalyticsProps } from "utils/analytics/AnalyticsProps";

export type ButtonProps = React.ComponentProps<typeof EDSButton> &
  AnalyticsProps;
export default function Button({
  analyticsName,
  analyticsSurface,
  analyticsProperties,
  onClick,
  ...props
}: ButtonProps) {
  const { trackEvent } = useAnalytics("Button " + analyticsName);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    trackEvent({
      eventName: analyticsName,
      eventType: ActionType.CLICK_BUTTON,
      analyticsSurface,
      extraProperties: analyticsProperties,
    });

    if (onClick) {
      onClick(event);
    }
  };

  return <EDSButton {...props} onClick={handleClick} />;
}

Button.displayName = "Button";
